import { createFileRoute } from '@tanstack/react-router';
import EngineTemperatureOnline from '../../../components/Graphs/EngineTemperature';

export const Route = createFileRoute('/_authenticated/graphs/temperature/$vehicleId')({
  beforeLoad: ({ context }) => {
    // requirePermission(PERMISSION_RIDES, ['read']);
    return {
      ...context,
      documentTitle: {
        main: 'enum.onlineMap.widget.types.engineTemperature',
        // suffix: 'menu.overviewTours',
      },
      isMenuDisabled: true,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: EngineTemperatureGraphRoute,
});

function EngineTemperatureGraphRoute() {
  const { vehicleId } = Route.useParams();

  return <EngineTemperatureOnline vehicleId={Number(vehicleId)} isPage />;
}
